var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import { usePage } from "./use-page";
import { pick } from 'lodash';
import { EntityContext } from "../components/context/entity-context";
import { useContext } from "react";
export function useEntity(entity) {
  var page = usePage();
  var providedEntity = useContext(EntityContext);

  if (entity) {
    return entity; // return what was given to us. This allows a component to pass in a prop-based entity, and have that echoed back (which will avoid differing usage of hooks)
  } // console.log("PROVIDED ENTITY", providedEntity);
  // first, pull from page context. This ensures the base info provided by the site generator is at least available 


  var pageContextEntity = pick(page, 'id', 'name', 'slug', 'entityTypeName', '__type', 'openGraph', 'path'); // next, augment this with data provided by the EntityProvider (if available)
  // @ts-ignore

  return __assign(__assign({}, pageContextEntity), providedEntity);
}
;